//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import exportacao from '../../common/resources/exportacoes';

export default {
  name: 'TermoAceiteLista',
  components: {

  },
  data() {
    return {
      termoAceiteResources: this.$api.termoAceite(this.$resource),

      pagination: {},
      totalPage: 0,
      searchQuery: '',
      headers: [
        { text: this.$tc('label.objetivo', 1), value: 'objetivo', sortable: false },
        { text: this.$tc('label.data_inicio', 1), value: 'dataInicio', sortable: false },
        { text: this.$tc('label.frequencia', 1), value: 'frequencia', sortable: false },
        { text: this.$tc('label.ativo', 1), value: 'indAtivo', sortable: false },
      ],
      termos: [],
    };
  },
  computed: {
    ...mapGetters('roles', [
      'getAllRoles',
    ]),
    ...mapGetters('usuario', [
      'usuarioLogado',
    ]),
    ...mapGetters('implantacao', [
      'indModoVarejo',
    ]),
    idUsuario() {
      return this.usuarioLogado.id;
    },
    canAccessPage() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter(el => el.startsWith('TERMO_ACEITE')).length;
    },
    canCRUD() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter(el => el === 'TERMO_ACEITE_CRUD').length;
    },
  },
  watch: {
    searchQuery() {
      if (this.timeoutTemp) {
        window.clearTimeout(this.timeoutTemp);
      }
      this.timeoutTemp = window.setTimeout(() => {
        this.buscarTermos();
      }, 500);
    },
    pagination: {
      handler() {
        this.buscarTermos();
      },
      deep: true,
    },
  },
  methods: {
    accessForbidden() {
      this.$router.push({ name: 'inicio' });
      this.$toast.create(this.$t('message.acesso_negado'), 'snack', 3E3);
    },
    abrirForm() {
      this.$router.push({ name: 'novoTermoAceite' });
    },
    buscarTermos() {
      const params = {
        tamanhoPagina: this.pagination.itemsPerPage || 10,
        numeroPagina: this.pagination.page || 1,
        filter: this.searchQuery,
      };

      this.termoAceiteResources.listarFiltrado(params).then((response) => {
        this.termos = response.data.resposta;
        this.totalPage = response.data.quantidadeRegistrosPagina;
      }, (err) => {
        this.$error(this, err);
      });
    },
    editar(item) {
      this.$router.push({ name: 'editarTermoAceite', params: { id: item.id } });
    },
    verDetalhes(item) {
      this.$router.push({ name: 'verTermoAceite', params: { id: item.id } });
    },
    ativarInativar(item) {
      const codigo = item.id;
      this.termoAceiteResources.ativacao({ codigo }, { codigo }).then(() => {
        item.indAtivo = !item.indAtivo;
        this.$toast.create(this.$t('message.atualizado_confira_tabela'), 'snack', 3E3);
      }, (err) => {
        this.$error(this, err);
      });
    },
    requestExportacao(cb) {
      this.exportar(cb, 'termo_aceite_usuario');
    },
    exportar(cb, nomeExportador, limit = 500, timeout = 120000) {
      const resource = exportacao(this.$http, timeout);
      const payload = this.idUsuario && nomeExportador === 'termo_aceite_usuario'
        ? { parametrosConsulta: {
          idUsuario: this.idUsuario,
        },
          limit,
        }
        : { limit };
      resource.download(nomeExportador, payload)
        .then(() => {
          this.$toast.create(this.$t('message.exportacao_download'), 'snack', 3E3);
        })
        .catch(() => {
          this.$toast.create('Erro ao exportar. Tente novamente.', 'snack', 3E3);
        });
    },
  },
  beforeMount() {
    if (!this.canAccessPage) {
      window.setTimeout(() => {
        this.accessForbidden();
      }, 1E3);
    }
  },
  mounted() {
    if (this.indModoVarejo) {
      this.headers.unshift(
        { text: this.$tc('label.acoes', 2), value: 'acoes', width: '2%', sortable: false },
        { text: this.$tc('label.descricao', 1), value: 'descricao', sortable: false },
        { text: this.$tc('label.grupo_fornecedor', 1), value: 'grupos_fornecedor', sortable: false },
      );
    } else {
      this.headers.unshift(
        { text: this.$tc('label.acoes', 2), value: 'acoes', width: '2%', sortable: false },
        { text: this.$tc('label.descricao', 1), value: 'descricao', sortable: false },
        { text: this.$tc('label.unidade_negocio', 1), value: 'unidade_negocio', sortable: false },
      );
    }
  },
};



// WEBPACK FOOTER //
// ./src/spa/termo-aceite/TermoAceiteLista.vue?vue&type=script&lang=js&